import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "rask-permissiontorask-denied",
    templateUrl: "./permissiontorask-denied.component.html",
    styleUrls: ["./permissiontorask-denied.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class PermissiontoraskDeniedComponent {

}
